import React from 'react';
import { Button, ButtonGroup, Collapse, Table } from 'reactstrap';

export default class ElementStatistics extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      elementSort: 'alpha-asc',
      collapse: false,
    };
  }

  toggle = () => {
    this.setState({ collapse: !this.state.collapse });
  }

  collapseButton = () => (<Button
    color="secondary"
    data-bs-toggle="collapse"
    href={'#elements'}
    aria-expanded="true"
    aria-controls="elements"
    onClick={this.toggle}
    style={{ width: '90px' }}
    title={!this.state.collapse ? 'collapse' : 'expand'}
  >
    {!this.state.collapse ? 'Collapse' : 'Expand'}
  </Button>)

  changeElementSort = (type) => {
    this.setState({ elementSort: type });
  }

  sortElementsAlphaAsc(a, b) {
    if (a.name > b.name) {
      return 1;
    } else if (a.name < b.name) {
      return -1;
    }
    return 0;
  }

  sortElementsAlphaDesc(a, b) {
    if (a.name < b.name) {
      return 1;
    } else if (a.name > b.name) {
      return -1;
    }
    return 0;
  }

  sortElementsNumericAsc(a, b) {
    if (a.count > b.count) {
      return 1;
    } else if (a.count < b.count) {
      return -1;
    }
    return 0;
  }

  sortElementsNumericDesc(a, b) {
    if (a.count < b.count) {
      return 1;
    } else if (a.count > b.count) {
      return -1;
    }
    return 0;
  }

  currentSort() {
    switch (this.state.elementSort) {
      case 'alpha-asc':
        return this.sortElementsAlphaAsc;
      case 'alpha-desc':
        return this.sortElementsAlphaDesc;
      case 'numeric-asc':
        return this.sortElementsNumericAsc;
      case 'numeric-desc':
        return this.sortElementsNumericDesc;
      default:
        return this.sortElementsAlphaAsc;
    }
  }

  render() {
    const data = this.props.data;
    data.sort(this.currentSort());
    return (<div className="stats-section">
      <h3>
        Elements
        <ButtonGroup style={{ float: 'right' }}>
          <Button
            id="el-sort-alpha-asc"
            title="sort elements ascending alphabetically"
            onClick={() => this.changeElementSort('alpha-asc')}
            style={{ float: 'none' }}
          >
            <i className="fa fa-sort-alpha-asc" />
          </Button>
          <Button
            id="el-sort-alpha-desc"
            title="sort elements descending alphabetically"
            onClick={() => this.changeElementSort('alpha-desc')}
            style={{ float: 'none' }}
          >
            <i className="fa fa-sort-alpha-desc" />
          </Button>
          <Button
            id="el-sort-numeric-asc"
            title="sort elements ascending numerically"
            onClick={() => this.changeElementSort('numeric-asc')}
            style={{ float: 'none' }}
          >
            <i className="fa fa-sort-numeric-asc" />
          </Button>
          <Button
            id="el-sort-numeric-desc"
            title="sort elements descending numerically"
            onClick={() => this.changeElementSort('numeric-desc')}
            style={{ float: 'none' }}
          >
            <i className="fa fa-sort-numeric-desc" />
          </Button>
          {this.collapseButton('elements')}
        </ButtonGroup>
      </h3>
      <div id="elements" className="collapse show">
        <p>
          <small>Elements in yellow are not ScML styles.</small>
        </p>
        <Table className="stats-table" hover responsive>
          <thead>
            <tr>
              <th>Name</th>
              <th>Count</th>
            </tr>
          </thead>
          <tbody>
            {data.map((datum, index) =>
              (<tr
                key={`el${index}`}
                className={datum.scml ? '' : 'table-warning'}
              >
                <td className="el-name">{datum.name}</td>
                <td className="el-count">{datum.count}</td>
              </tr>),
            )}
          </tbody>
        </Table>
      </div>
    </div>);
  }
}
